import {Column} from 'react-table'
import {formatDate} from '../../../../../utils/date'
import {Judi} from '../../core/_models'
import {JudiCustomHeader} from './JudiCustomHeader'
import {JudiActionsCell} from './JudiActionsCell'
import {JudolCustomHeader} from '../../../../judol/judol-list/table/columns/JudolCustomHeader'
import {formatAttentionLevel} from '../../../../../utils/string'

const judiColumns: ReadonlyArray<Column<Judi>> = [
  {
    Header: (props) => (
      <JudiCustomHeader
        tableProps={props}
        title='No'
        className='min-w-75px'
        enableSort={false}
      />
    ),
    accessor: 'id',
    id: 'id',
    Cell: ({...props}) => (
      <>{props.row.index + 1}</>
    )
  },
  {
    Header: (props) => (
      <JudiCustomHeader
        tableProps={props}
        title='Wilayah'
        className='min-w-150px'
        enableSort={true}
      />
    ),
    accessor: 'satwilName',
    id: 'satwilName',
  },
  {
    Header: (props) => (
      <JudiCustomHeader tableProps={props} title='No LP' className='min-w-125px' enableSort={false} />
    ),
    accessor: 'policeReportNo',
    id: 'policeReportNo',
  },
  {
    Header: (props) => (
      <JudiCustomHeader
        tableProps={props}
        title='Level Atensi'
        className='min-w-125px'
        enableSort={true}
      />
    ),
    accessor: 'attentionLevel',
    id: 'attentionLevel',
    Cell: ({...props}) => (
      <>{formatAttentionLevel(props.data[props.row.index].attentionLevel)}</>
    )
  },
  {
    Header: (props) => (
      <JudiCustomHeader
        tableProps={props}
        title='Tahap'
        className='min-w-125px'
        enableSort={false}
      />
    ),
    accessor: 'caseStatusName',
    id: 'caseStatusName',
  },
  {
    Header: (props) => (
      <JudiCustomHeader
        tableProps={props}
        title='Tanggal LP'
        className='min-w-125px'
        enableSort={false}
      />
    ),
    accessor: 'policeReportDate',
    id: 'policeReportDate',
    Cell: ({...props}) => (
      <>{formatDate(props.data[props.row.index].policeReportDate ?? new Date())}</>
    ),
  },
  {
    Header: (props) => (
      <JudiCustomHeader
        tableProps={props}
        title='Tanggal Input'
        className='min-w-150px'
        enableSort={true}
      />
    ),
    accessor: 'createdAt',
    id: 'createdAt',
    Cell: ({...props}) => (
      <>{formatDate(props.data[props.row.index].createdAt || '')}</>
    ),
  },
  {
    Header: (props) => (
      <JudiCustomHeader
        tableProps={props}
        title='Status'
        className='min-w-125px'
        enableSort={false}
        stickyEnd={100}
        stickyBorder={true}
      />
    ),
    accessor: 'statusName',
    id: 'statusName',
  },
  {
    Header: (props) => (
      <JudiCustomHeader
        tableProps={props}
        title='Actions'
        className='text-end w-150px'
        enableSort={false}
        stickyEnd={0}
      />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <JudiActionsCell
        id={props.data[props.row.index].id}
        name={props.data[props.row.index].policeReportNo ?? ''}
        permission={props.data[props.row.index].button}
      />
    ),
  },
]

export {judiColumns}
